module.exports = __webpack_public_path__ + "img/Organigrama.de366c44.png";